module.exports = __webpack_public_path__ + "static/bodycare-yoga-d518e0b307620009c74f1982ef8c5abe.svg";